import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    Typography,
    Tabs,
    Tab,
    Card,
    CardContent,
    Input,
    Alert,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    TextField,
    IconButton,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { CloudUpload, ContentCopy, Email, Visibility, Download, Close } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import { uploadExistingInfluencers, getPendingInfluencers, getAssignedInfluencers, getCompletedInfluencers, updateInfluencerStatus, getUsers, bulkAssignInfluencers } from '../services/api';

function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index}>
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function SuperAdminInfluencers({ user }) {

    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState(0);
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [dragOver, setDragOver] = useState(false);
    const [pendingInfluencers, setPendingInfluencers] = useState([]);
    const [assignedInfluencers, setAssignedInfluencers] = useState([]);
    const [completedInfluencers, setCompletedInfluencers] = useState([]);
    const [inProgressInfluencers, setInProgressInfluencers] = useState([]);
    const [notInterestedInfluencers, setNotInterestedInfluencers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', severity: 'success' });
    const [selectedRows, setSelectedRows] = useState([]);
    const [assignedSelectedRows, setAssignedSelectedRows] = useState([]);
    const [completedSelectedRows, setCompletedSelectedRows] = useState([]);
    const [languageFilter, setLanguageFilter] = useState('');
    const [stateFilter, setStateFilter] = useState('');
    const [assignModalOpen, setAssignModalOpen] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedInfluencerIds, setSelectedInfluencerIds] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [emailInput, setEmailInput] = useState('');
    const [selectedInfluencerId, setSelectedInfluencerId] = useState('');
    const [userFilter, setUserFilter] = useState('');
    const [mobileFilter, setMobileFilter] = useState('');
    const [filteredAssignedCount, setFilteredAssignedCount] = useState(0);
    const [filteredCompletedCount, setFilteredCompletedCount] = useState(0);
    const [filteredPendingCount, setFilteredPendingCount] = useState(0);
    const [filteredInProgressCount, setFilteredInProgressCount] = useState(0);
    const [filteredNotInterestedCount, setFilteredNotInterestedCount] = useState(0);
    const [showUploadSection, setShowUploadSection] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const pendingColumns = [
        { field: 'sno', headerName: 'S.No', width: 80 },
        { field: 'username', headerName: 'Username', width: 150 },
        { field: 'businessEmail', headerName: 'Business Email', width: 200 },
        { field: 'name', headerName: 'Name', width: 150 },
        { field: 'profileLink', headerName: 'Profile Link', width: 250 },
        { field: 'market', headerName: 'Market(Language)', width: 150 },
        {
            field: 'actions',
            headerName: 'Assign',
            width: 120,
            renderCell: (params) => (
                <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                        setSelectedInfluencerIds([params.row.id]);
                        setAssignModalOpen(true);
                    }}
                >
                    Assign
                </Button>
            ),
        },
    ];

    const assignedColumns = [
        { field: 'sno', headerName: 'S.No', width: 80 },
        { field: 'assignedTo', headerName: 'Assigned To', width: 150 },
        { field: 'campaignId', headerName: 'campaign Name', width: 150 },
        { field: 'givenBy', headerName: 'Given By', width: 150 },
        { field: 'username', headerName: 'Username', width: 150 },
        { field: 'businessEmail', headerName: 'Business Email', width: 200 },
        { field: 'name', headerName: 'Name', width: 150 },
        { field: 'mobile', headerName: 'Mobile', width: 150 },
        { field: 'profileLink', headerName: 'Profile Link', width: 250 },
        { field: 'market', headerName: 'Market(Language)', width: 150 },
        { field: 'state', headerName: 'State', width: 150 },
        {
            field: 'modifiedAt',
            headerName: 'Modified At',
            width: 150,
            valueFormatter: (params) => {
                if (!params.value) return '-';
                const date = new Date(params.value);
                const day = date.getDate();
                const month = date.toLocaleString('en-US', { month: 'short' });
                const year = date.getFullYear();
                return `${day} ${month} ${year}`;
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => (
                <Select
                    size="small"
                    value={params.row.status || 'assigned'}
                    onChange={(e) => handleStatusUpdate(params.row.id, e.target.value)}
                    sx={{ minWidth: 120 }}
                >
                    <MenuItem value="assigned">Assigned</MenuItem>
                    <MenuItem value="in_progress">In Progress</MenuItem>
                    <MenuItem value="not_interested">Not Interested</MenuItem>
                    {/* <MenuItem value="completed">Completed</MenuItem> */}
                </Select>
            ),
        },
        { field: 'remark', headerName: 'Remark', width: 120 },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 120,
            renderCell: (params) => (
                <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                        setSelectedInfluencerIds([params.row.id]);
                        setAssignModalOpen(true);
                    }}
                >
                    Reassign
                </Button>
            ),
        },
    ];

    const completedColumns = [
        { field: 'sno', headerName: 'S.No', width: 80 },
        { field: 'influencerCode', headerName: 'Influencer ID', width: 100 },
        { field: 'assignedTo', headerName: 'Assigned To', width: 150 },
        { field: 'campaignId', headerName: 'campaign Name', width: 150 },
        { field: 'givenBy', headerName: 'Given By', width: 150 },
        { field: 'username', headerName: 'Username', width: 150 },
        { field: 'businessEmail', headerName: 'Business Email', width: 200 },
        { field: 'name', headerName: 'Name', width: 150 },
        { field: 'mobile', headerName: 'Mobile', width: 150 },
        { field: 'profileLink', headerName: 'Profile Link', width: 250 },
        { field: 'market', headerName: 'Market(Language)', width: 150 },
        { field: 'state', headerName: 'State', width: 150 },
        { field: 'remark', headerName: 'Remark', width: 150 },
        {
            field: 'modifiedAt',
            headerName: 'Modified At',
            width: 150,
            valueFormatter: (params) => {
                if (!params.value) return '-';
                const date = new Date(params.value);
                const day = date.getDate();
                const month = date.toLocaleString('en-US', { month: 'short' });
                const year = date.getFullYear();
                return `${day} ${month} ${year}`;
            },
        },
        {
            field: 'view',
            headerName: 'View Form',
            width: 120,
            renderCell: (params) => (
                <Button
                    size="small"
                    variant="contained"
                    startIcon={<Visibility />}
                    onClick={() => navigate(`/influencer/${params.row.influencerFormId?._id || params.row.influencerFormId}`)}
                    disabled={!params.row.influencerFormId}
                >
                    View
                </Button>
            ),
        },
    ];

    const inProgressColumns = [
        { field: 'sno', headerName: 'S.No', width: 80 },
        { field: 'assignedTo', headerName: 'Assigned To', width: 150 },
        { field: 'campaignId', headerName: 'campaign Name', width: 150 },
        { field: 'givenBy', headerName: 'Given By', width: 150 },
        { field: 'username', headerName: 'Username', width: 150 },
        { field: 'businessEmail', headerName: 'Business Email', width: 200 },
        { field: 'name', headerName: 'Name', width: 150 },
        { field: 'mobile', headerName: 'Mobile', width: 150 },
        { field: 'profileLink', headerName: 'Profile Link', width: 250 },
        { field: 'market', headerName: 'Market(Language)', width: 150 },
        { field: 'state', headerName: 'State', width: 150 },
        { field: 'remark', headerName: 'Remark', width: 150 },
        {
            field: 'modifiedAt',
            headerName: 'Modified At',
            width: 150,
            valueFormatter: (params) => {
                if (!params.value) return '-';
                const date = new Date(params.value);
                const day = date.getDate();
                const month = date.toLocaleString('en-US', { month: 'short' });
                const year = date.getFullYear();
                return `${day} ${month} ${year}`;
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => (
                <Select
                    size="small"
                    value={params.row.status || 'in_progress'}
                    onChange={(e) => handleStatusUpdate(params.row.id, e.target.value)}
                    sx={{ minWidth: 120 }}
                >
                    <MenuItem value="assigned">Assigned</MenuItem>
                    <MenuItem value="in_progress">In Progress</MenuItem>
                    <MenuItem value="not_interested">Not Interested</MenuItem>
                </Select>
            ),
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 120,
            renderCell: (params) => (
                <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                        setSelectedInfluencerIds([params.row.id]);
                        setAssignModalOpen(true);
                    }}
                >
                    Reassign
                </Button>
            ),
        },
    ];

    const notInterestedColumns = [
        { field: 'sno', headerName: 'S.No', width: 80 },
        { field: 'assignedTo', headerName: 'Assigned To', width: 150 },
        { field: 'campaignId', headerName: 'campaign Name', width: 150 },
        { field: 'givenBy', headerName: 'Given By', width: 150 },
        { field: 'username', headerName: 'Username', width: 150 },
        { field: 'businessEmail', headerName: 'Business Email', width: 200 },
        { field: 'name', headerName: 'Name', width: 150 },
        { field: 'mobile', headerName: 'Mobile', width: 150 },
        { field: 'profileLink', headerName: 'Profile Link', width: 250 },
        { field: 'market', headerName: 'Market(Language)', width: 150 },
        { field: 'state', headerName: 'State', width: 150 },
        { field: 'remark', headerName: 'Remark', width: 120 },
        {
            field: 'modifiedAt',
            headerName: 'Modified At',
            width: 150,
            valueFormatter: (params) => {
                if (!params.value) return '-';
                const date = new Date(params.value);
                const day = date.getDate();
                const month = date.toLocaleString('en-US', { month: 'short' });
                const year = date.getFullYear();
                return `${day} ${month} ${year}`;
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => (
                <Select
                    size="small"
                    value={params.row.status || 'not_interested'}
                    onChange={(e) => handleStatusUpdate(params.row.id, e.target.value)}
                    sx={{ minWidth: 120 }}
                >
                    <MenuItem value="assigned">Assigned</MenuItem>
                    <MenuItem value="in_progress">In Progress</MenuItem>
                    <MenuItem value="not_interested">Not Interested</MenuItem>
                </Select>
            ),
        },
    ];

    useEffect(() => {
        fetchAllInfluencers();
        fetchUsers();
    }, []);

    useEffect(() => {
        updateFilteredCounts();
    }, [assignedInfluencers, completedInfluencers, pendingInfluencers, inProgressInfluencers, notInterestedInfluencers, userFilter, languageFilter, stateFilter, mobileFilter, fromDate, toDate]);

    const updateFilteredCounts = () => {
        const assignedFiltered = getFilteredAssignedRows();
        const completedFiltered = getFilteredCompletedRows();
        const inProgressFiltered = getFilteredInProgressRows();
        const notInterestedFiltered = getFilteredNotInterestedRows();
        const totalPending = assignedFiltered.length + completedFiltered.length + inProgressFiltered.length + notInterestedFiltered.length;
        setFilteredPendingCount(totalPending);
        setFilteredAssignedCount(assignedFiltered.length);
        setFilteredCompletedCount(completedFiltered.length);
        setFilteredInProgressCount(inProgressFiltered.length);
        setFilteredNotInterestedCount(notInterestedFiltered.length);
    };

    const fetchUsers = async () => {
        try {
            const response = await getUsers();
            const filteredUsers = response.data.filter(user => user.role !== 'superadmin' && user.role !== 'super_admin');
            setUsers(filteredUsers);
        } catch (error) {
            console.error('Fetch users error:', error);
        }
    };

    const fetchAllInfluencers = async () => {
        setLoading(true);
        try {
            const [pendingRes, assignedRes, completedRes] = await Promise.all([
                getPendingInfluencers(),
                getAssignedInfluencers(),
                getCompletedInfluencers()
            ]);

            setPendingInfluencers(pendingRes.data?.data || []);
            setAssignedInfluencers(assignedRes.data?.data || []);
            setCompletedInfluencers(completedRes.data?.data || []);

            // Fetch in progress and not interested
            await fetchInProgressInfluencers();
            await fetchNotInterestedInfluencers();
        } catch (error) {
            console.error('Fetch error:', error);
            showAlert('Failed to fetch influencers', 'error');
        } finally {
            setLoading(false);
        }
    };

    const fetchInProgressInfluencers = async () => {
        try {
            const { default: api } = await import('../services/api');
            const response = await api.get('/existing-influencers/in-progress');
            setInProgressInfluencers(response.data?.data || []);
        } catch (error) {
            console.error('Failed to fetch in-progress influencers:', error);
        }
    };

    const fetchNotInterestedInfluencers = async () => {
        try {
            const { default: api } = await import('../services/api');
            const response = await api.get('/existing-influencers/not-interested');
            setNotInterestedInfluencers(response.data?.data || []);
        } catch (error) {
            console.error('Failed to fetch not-interested influencers:', error);
        }
    };

    const formatDate = (value) => {
        if (!value || value === '-') return '-';
        const date = new Date(value);
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    const handleExportToExcel = () => {
        let rows, sheetName;
        switch (tabValue) {
            case 0: rows = getFilteredAssignedRows(); sheetName = 'Assigned'; break;
            case 1: rows = getFilteredInProgressRows(); sheetName = 'In Progress'; break;
            case 2: rows = getFilteredNotInterestedRows(); sheetName = 'Not Interested'; break;
            case 3: rows = getFilteredCompletedRows(); sheetName = 'Completed'; break;
            default: rows = []; sheetName = 'Data';
        }

        const data = rows.map(row => ({
            'S.No': row.sno,
            'Assigned To': row.assignedTo || '-',
            'Campaign Name': row.campaignId || '-',
            'Given By': row.givenBy || '-',
            'Username': row.username || '-',
            'Business Email': row.businessEmail || '-',
            'Name': row.name || '-',
            'Mobile': row.mobile || '-',
            'Profile Link': row.profileLink || '-',
            'Market (Language)': row.market || '-',
            'State': row.state || '-',
            'Remark': row.remark || '-',
            // 'Modified At': formatDate(row.modifiedAt),
            // 'Status': row.status || '-',
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        XLSX.writeFile(wb, `${sheetName}_Influencers_${new Date().toISOString().split('T')[0]}.xlsx`);
        toast.success('Data exported successfully!');
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        validateAndSetFile(selectedFile);
    };

    const validateAndSetFile = (selectedFile) => {
        if (selectedFile && selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            setFile(selectedFile);
        } else {
            showAlert('Please select a valid Excel file (.xlsx)', 'error');
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const droppedFile = e.dataTransfer.files[0];
        validateAndSetFile(droppedFile);
    };

    const handleUpload = async () => {
        if (!file) {
            showAlert('Please select a file first', 'error');
            return;
        }

        setUploading(true);
        const formData = new FormData();
        formData.append('excel', file);

        try {
            await uploadExistingInfluencers(formData);
            showAlert('Excel file uploaded successfully', 'success');
            setFile(null);
            fetchAllInfluencers();
        } catch (error) {
            showAlert('Please ensure Profile Link is provided for all rows. IC Name is optional but will auto-assign if provided.', 'error');
        } finally {
            setUploading(false);
        }
    };

    const handleStatusChange = async (id, newStatus) => {
        try {
            await updateInfluencerStatus(id, newStatus);
            showAlert(`Status updated to ${newStatus}`, 'success');
            fetchAllInfluencers();
        } catch (error) {
            showAlert('Failed to update status', 'error');
        }
    };

    const handleStatusUpdate = async (id, status) => {
        try {
            const { default: api } = await import('../services/api');
            await api.put(`/existing-influencers/${id}/status`, { status: status });
            showAlert(`Status updated to ${status.replace('_', ' ')}`, 'success');
            fetchAllInfluencers();
        } catch (error) {
            showAlert('Failed to update status', 'error');
        }
    };

    const handleUserAssign = async () => {
        if (!selectedUserId) {
            showAlert('Please select a user', 'error');
            return;
        }
        try {
            if (selectedInfluencerIds.length > 0) {
                console.log('Assigning IDs:', selectedInfluencerIds);
                await bulkAssignInfluencers(selectedInfluencerIds, selectedUserId);
                showAlert(`${selectedInfluencerIds.length} influencer(s) assigned successfully`, 'success');
                clearCurrentSelectedRows();
            }
            setAssignModalOpen(false);
            setSelectedUserId('');
            setSelectedInfluencerIds([]);
            fetchAllInfluencers();
        } catch (error) {
            console.error('Assignment error:', error);
            showAlert('Failed to assign influencer(s)', 'error');
        }
    };

    const showAlert = (message, severity) => {
        setAlert({ show: true, message, severity });
        setTimeout(() => setAlert({ show: false, message: '', severity: 'success' }), 3000);
    };

    const getPendingRows = () => {
        return pendingInfluencers
            .filter(inf => !languageFilter || inf.market === languageFilter)
            .map((inf, index) => ({
                ...inf,
                id: inf._id,
                sno: index + 1,
                businessEmail: inf.businessEmail || '-',
                assignedTo: inf.assignedTo ? (inf.assignedTo.name || inf.assignedTo.username) : '-'
            }));
    };

    const filterByDate = (inf) => {
        if (!fromDate && !toDate) return true;
        if (!inf.updatedAt) return false;
        const updatedDate = dayjs(inf.updatedAt);
        if (fromDate && updatedDate.isBefore(dayjs(fromDate), 'day')) return false;
        if (toDate && updatedDate.isAfter(dayjs(toDate), 'day')) return false;
        return true;
    };

    const getFilteredAssignedRows = () => {
        return assignedInfluencers
            .filter(inf => !languageFilter || inf.market === languageFilter)
            .filter(inf => !stateFilter || inf.state === stateFilter)
            .filter(inf => !userFilter || (inf.assignedTo && inf.assignedTo._id === userFilter))
            .filter(inf => !mobileFilter || (mobileFilter === 'with' ? inf.mobile : !inf.mobile))
            .filter(filterByDate)
            .map((inf, index) => ({
                ...inf,
                id: inf._id,
                campaignId: inf.campaignId ? inf.campaignId.campaignName : '-',
                sno: index + 1,
                username: inf.username || '-',
                name: inf.name || '-',
                givenBy: inf.givenBy || '-',
                mobile: inf.mobile || '-',
                state: inf.state || '-',
                businessEmail: inf.businessEmail || '-',
                assignedTo: inf.assignedTo ? (inf.assignedTo.name || inf.assignedTo.username) : '-',
                status: inf.status || 'assigned',
                remark: inf.remark ? (inf.remark) : '-',
                modifiedAt: inf.updatedAt || '-',
            }));
    };

    const getFilteredCompletedRows = () => {
        return completedInfluencers
            .filter(inf => !languageFilter || inf.market === languageFilter)
            .filter(inf => !stateFilter || inf.state === stateFilter)
            .filter(inf => !userFilter || (inf.assignedTo && inf.assignedTo._id === userFilter))
            .filter(inf => !mobileFilter || (mobileFilter === 'with' ? inf.mobile : !inf.mobile))
            .filter(filterByDate)
            .map((inf, index) => ({
                ...inf,
                id: inf._id,
                sno: index + 1,
                influencerCode: inf.influencerFormId ? inf.influencerFormId.influencerCode : '-',
                mobile: inf.mobile || '-',
                campaignId: inf.campaignId ? inf.campaignId?.campaignName : '-',
                state: inf.state || '-',
                businessEmail: inf.businessEmail || '-',
                assignedTo: inf.assignedTo ? (inf.assignedTo.name || inf.assignedTo.username) : '-',
                givenBy: inf.givenBy || '-',
                remark: inf.remark ? (inf.remark) : '-',
                modifiedAt: inf.updatedAt || '-',
            }));
    };

    const getFilteredInProgressRows = () => {
        return inProgressInfluencers
            .filter(inf => !languageFilter || inf.market === languageFilter)
            .filter(inf => !stateFilter || inf.state === stateFilter)
            .filter(inf => !userFilter || (inf.assignedTo && inf.assignedTo._id === userFilter))
            .filter(inf => !mobileFilter || (mobileFilter === 'with' ? inf.mobile : !inf.mobile))
            .filter(filterByDate)
            .map((inf, index) => ({
                ...inf,
                id: inf._id,
                sno: index + 1,
                campaignId: inf.campaignId ? inf.campaignId?.campaignName : '-',
                username: inf.username || '-',
                name: inf.name || '-',
                mobile: inf.mobile || '-',
                state: inf.state || '-',
                businessEmail: inf.businessEmail || '-',
                assignedTo: inf.assignedTo ? (inf.assignedTo.name || inf.assignedTo.username) : '-',
                givenBy: inf.givenBy || '-',
                status: inf.status || 'in_progress',
                remark: inf.remark ? (inf.remark) : '-',
                modifiedAt: inf.updatedAt || '-',
            }));
    };

    const getFilteredNotInterestedRows = () => {
        return notInterestedInfluencers
            .filter(inf => !languageFilter || inf.market === languageFilter)
            .filter(inf => !stateFilter || inf.state === stateFilter)
            .filter(inf => !userFilter || (inf.assignedTo && inf.assignedTo._id === userFilter))
            .filter(inf => !mobileFilter || (mobileFilter === 'with' ? inf.mobile : !inf.mobile))
            .filter(filterByDate)
            .map((inf, index) => ({
                ...inf,
                id: inf._id,
                sno: index + 1,
                campaignId: inf.campaignId ? inf.campaignId?.campaignName : '-',
                username: inf.username || '-',
                name: inf.name || '-',
                mobile: inf.mobile || '-',
                state: inf.state || '-',
                businessEmail: inf.businessEmail || '-',
                assignedTo: inf.assignedTo ? (inf.assignedTo.name || inf.assignedTo.username) : '-',
                givenBy: inf.givenBy || '-',
                status: inf.status || 'not_interested',
                remark: inf.remark ? (inf.remark) : '-',
                modifiedAt: inf.updatedAt || '-',
            }));
    };

    const getUniqueLanguages = () => {
        const allInfluencers = [...pendingInfluencers, ...assignedInfluencers, ...completedInfluencers, ...inProgressInfluencers, ...notInterestedInfluencers];
        const languages = allInfluencers
            .map(inf => inf.market)
            .filter(market => market && market !== null)
            .filter((value, index, self) => self.indexOf(value) === index);
        return languages;
    };

    const getUniqueStates = () => {
        const allInfluencers = [...pendingInfluencers, ...assignedInfluencers, ...completedInfluencers, ...inProgressInfluencers, ...notInterestedInfluencers];
        const states = allInfluencers
            .map(inf => inf.state)
            .filter(state => state && state !== null)
            .filter((value, index, self) => self.indexOf(value) === index);
        return states;
    };

    const getCurrentSelectedRows = () => {
        const selected = {
            0: assignedSelectedRows,
            1: completedSelectedRows
        }[tabValue] || [];
        return selected;
    };

    const clearCurrentSelectedRows = () => {
        switch (tabValue) {
            case 0: setAssignedSelectedRows([]); break;
            case 1: setCompletedSelectedRows([]); break;
        }
    };

    const handleCopyId = (id) => {
        navigator.clipboard.writeText(id);
        showAlert('ID copied to clipboard', 'success');
    };

    const handleSendEmailClick = (id) => {
        setSelectedInfluencerId(id);
        setEmailInput('');
        setEmailModalOpen(true);
    };

    const handleSendEmail = async () => {
        if (!emailInput.trim()) {
            showAlert('Please enter an email address', 'error');
            return;
        }
        try {
            const { default: api } = await import('../services/api');
            const formUrl = `${window.location.origin}/form/${user?.id}/0/${selectedInfluencerId}`;
            await api.post('/send-form-email', { email: emailInput, formUrl: formUrl });
            showAlert('Email sent successfully', 'success');
            setEmailModalOpen(false);
            setEmailInput('');
            setSelectedInfluencerId('');
        } catch (error) {
            showAlert('Failed to send email', 'error');
        }
    };

    const handleViewForm = (influencerFormId) => {
        if (influencerFormId) {
            window.open(`${window.location.origin}/#/influencer/${influencerFormId}`, '_blank');
        }
    };

    const handleDownloadSample = () => {
        try {
            const link = document.createElement('a');
            link.href = `${process.env.REACT_APP_BASE_URL}/sample format.xlsx`;
            link.download = 'sample format.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Failed to download sample format:', error);
            showAlert('Failed to download sample format', 'error');
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    Existing Influencers
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<CloudUpload />}
                    onClick={() => setShowUploadSection(!showUploadSection)}
                // sx={{ color: '#5386e4', borderColor: '#5386e4' }}
                >
                    Upload Excel
                </Button>
            </Box>

            {alert.show && (
                <Alert severity={alert.severity} sx={{ mb: 2 }}>
                    {alert.message}
                </Alert>
            )}

            {showUploadSection && (
                <Card sx={{ mb: 3 }}>
                    <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Typography variant="h6">
                                Upload Excel File
                            </Typography>
                            <IconButton
                                onClick={() => setShowUploadSection(false)}
                                sx={{ color: '#5386e4' }}
                            >
                                <Close />
                            </IconButton>
                        </Box>
                        <Box
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            sx={{
                                border: `2px dashed ${dragOver ? '#5386e4' : '#ccc'}`,
                                borderRadius: 2,
                                p: 4,
                                textAlign: 'center',
                                bgcolor: dragOver ? '#f0f7ff' : '#fafafa',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                mb: 2
                            }}
                            onClick={() => document.getElementById('file-input').click()}
                        >
                            <CloudUpload sx={{ fontSize: 48, color: '#5386e4', mb: 2 }} />
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                {file ? file.name : 'Drag & Drop Excel File Here'}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                or click to browse files
                            </Typography>
                            <input
                                id="file-input"
                                type="file"
                                accept=".xlsx"
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                            <Button
                                variant="contained"
                                startIcon={<CloudUpload />}
                                onClick={handleUpload}
                                disabled={!file || uploading}
                            >
                                {uploading ? 'Uploading...' : 'Upload'}
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<Download />}
                                onClick={handleDownloadSample}
                            >
                                Sample Format
                            </Button>
                            {file && (
                                <Button
                                    variant="outlined"
                                    onClick={() => setFile(null)}
                                >
                                    Clear
                                </Button>
                            )}
                        </Box>
                    </CardContent>
                </Card>
            )}

            <Card>
                <CardContent>
                    <Box sx={{ mb: 3, display: 'flex', gap: 3 }}>
                        <Card sx={{ minWidth: 180, bgcolor: '#e3f2fd', height: '83px' }}>
                            <CardContent sx={{ textAlign: 'center', py: 2 }}>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                                    {filteredPendingCount}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Assigned
                                </Typography>
                            </CardContent>
                        </Card>
                        <Card sx={{ minWidth: 180, bgcolor: '#e1f5fe', height: '83px' }}>
                            <CardContent sx={{ textAlign: 'center', py: 2 }}>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#0277bd' }}>
                                    {filteredInProgressCount}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    In Progress
                                </Typography>
                            </CardContent>
                        </Card>
                        <Card sx={{ minWidth: 180, bgcolor: '#ffebee', height: '83px' }}>
                            <CardContent sx={{ textAlign: 'center', py: 2 }}>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#d32f2f' }}>
                                    {filteredNotInterestedCount}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Not Interested
                                </Typography>
                            </CardContent>
                        </Card>
                        <Card sx={{ minWidth: 180, bgcolor: '#e8f5e8', height: '83px' }}>
                            <CardContent sx={{ textAlign: 'center', py: 2 }}>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
                                    {filteredCompletedCount}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Completed
                                </Typography>
                            </CardContent>
                        </Card>
                        <Card sx={{ minWidth: 180, bgcolor: '#fff3e0', height: '83px' }}>
                            <CardContent sx={{ textAlign: 'center', py: 2 }}>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#f57c00' }}>
                                    {filteredAssignedCount}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Pending
                                </Typography>
                            </CardContent>
                        </Card>
                    </Box>
                    <Box sx={{ mb: 2, display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                            <FormControl size="small" sx={{ minWidth: 200 }}>
                                <InputLabel>Filter by Market</InputLabel>
                                <Select
                                    value={languageFilter}
                                    label="Filter by Market"
                                    onChange={(e) => setLanguageFilter(e.target.value)}
                                >
                                    <MenuItem value="">All Languages</MenuItem>
                                    {getUniqueLanguages().map((language) => (
                                        <MenuItem key={language} value={language}>
                                            {language}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small" sx={{ minWidth: 200 }}>
                                <InputLabel>Filter by State</InputLabel>
                                <Select
                                    value={stateFilter}
                                    label="Filter by State"
                                    onChange={(e) => setStateFilter(e.target.value)}
                                >
                                    <MenuItem value="">All States</MenuItem>
                                    {getUniqueStates().map((state) => (
                                        <MenuItem key={state} value={state}>
                                            {state}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small" sx={{ minWidth: 200 }}>
                                <InputLabel>Filter by User</InputLabel>
                                <Select
                                    value={userFilter}
                                    label="Filter by User"
                                    onChange={(e) => setUserFilter(e.target.value)}
                                >
                                    <MenuItem value="">All Users</MenuItem>
                                    {users.filter(user => user.role == 'onboarder').map((user) => (
                                        <MenuItem key={user._id} value={user._id}>
                                            {user.name || user.username}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small" sx={{ minWidth: 200 }}>
                                <InputLabel>Filter by Mobile</InputLabel>
                                <Select
                                    value={mobileFilter}
                                    label="Filter by Mobile"
                                    onChange={(e) => setMobileFilter(e.target.value)}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="with">With Mobile</MenuItem>
                                    <MenuItem value="without">Without Mobile</MenuItem>
                                </Select>
                            </FormControl>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="From Date"
                                    value={fromDate}
                                    onChange={(newValue) => setFromDate(newValue)}
                                    format="DD/MM/YYYY"
                                    renderInput={(params) => <TextField {...params} size="small" sx={{ minWidth: 200 }} />}
                                />
                                <DatePicker
                                    label="To Date"
                                    value={toDate}
                                    onChange={(newValue) => setToDate(newValue)}
                                    format="DD/MM/YYYY"
                                    renderInput={(params) => <TextField {...params} size="small" sx={{ minWidth: 200 }} />}
                                />
                            </LocalizationProvider>
                        </Box>
                        {/* <Button
                            variant="contained"
                            disabled={getCurrentSelectedRows().length === 0}
                            onClick={() => {
                                setSelectedInfluencerIds(getCurrentSelectedRows());
                                setAssignModalOpen(true);
                            }}
                        >
                            Assign Selected {getCurrentSelectedRows().length > 0 ? `(${getCurrentSelectedRows().length})` : ''}
                        </Button> */}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Tabs value={tabValue} onChange={(e, newValue) => {
                            setAssignedSelectedRows([]);
                            setCompletedSelectedRows([]);
                            setTabValue(newValue);
                        }}>
                            <Tab label={`Assigned (${filteredAssignedCount})`} />
                            <Tab label={`In Progress (${filteredInProgressCount})`} />
                            <Tab label={`Not Interested (${filteredNotInterestedCount})`} />
                            <Tab label={`Completed (${filteredCompletedCount})`} />
                        </Tabs>
                        <Button
                            variant="contained"
                            startIcon={<Download />}
                            onClick={handleExportToExcel}
                            sx={{ bgcolor: '#c5e86d', color: '#1a1d29', '&:hover': { bgcolor: '#b0d060' } }}
                        >
                            Export to Excel
                        </Button>
                    </Box>

                    <TabPanel value={tabValue} index={0}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                            <Button
                                variant="contained"
                                disabled={assignedSelectedRows.length === 0}
                                onClick={() => {
                                    setSelectedInfluencerIds(assignedSelectedRows);
                                    setAssignModalOpen(true);
                                }}
                            >
                                Reassign Selected {assignedSelectedRows.length > 0 ? `(${assignedSelectedRows.length})` : ''}
                            </Button>
                        </Box>
                        <DataGrid
                            rows={getFilteredAssignedRows()}
                            columns={assignedColumns}
                            pageSize={10}
                            loading={loading}
                            autoHeight
                            checkboxSelection
                            onSelectionModelChange={(newSelection) => {
                                setAssignedSelectedRows(newSelection);
                            }}
                            rowSelectionModel={assignedSelectedRows}
                            getRowId={(row) => row.id}
                        />
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                            <Button
                                variant="contained"
                                disabled={assignedSelectedRows.length === 0}
                                onClick={() => {
                                    setSelectedInfluencerIds(assignedSelectedRows);
                                    setAssignModalOpen(true);
                                }}
                            >
                                Reassign Selected {assignedSelectedRows.length > 0 ? `(${assignedSelectedRows.length})` : ''}
                            </Button>
                        </Box>
                        <DataGrid
                            rows={getFilteredInProgressRows()}
                            columns={inProgressColumns}
                            pageSize={10}
                            loading={loading}
                            autoHeight
                            checkboxSelection
                            onSelectionModelChange={(newSelection) => {
                                setAssignedSelectedRows(newSelection);
                            }}
                            getRowId={(row) => row.id}
                        />
                    </TabPanel>

                    <TabPanel value={tabValue} index={2}>
                        <DataGrid
                            rows={getFilteredNotInterestedRows()}
                            columns={notInterestedColumns}
                            pageSize={10}
                            loading={loading}
                            autoHeight
                            getRowId={(row) => row.id}
                        />
                    </TabPanel>
                    <TabPanel value={tabValue} index={3}>
                        <DataGrid
                            rows={getFilteredCompletedRows()}
                            columns={completedColumns}
                            pageSize={10}
                            loading={loading}
                            autoHeight
                            onRowSelectionModelChange={(newSelection) => {
                                console.log('Completed selection changed:', newSelection);
                                setCompletedSelectedRows(newSelection);
                            }}
                            rowSelectionModel={completedSelectedRows}
                            getRowId={(row) => row.id}
                        />
                    </TabPanel>
                </CardContent>
            </Card>

            <Dialog open={assignModalOpen} onClose={() => setAssignModalOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {selectedInfluencerIds.length > 0 ? `Assign ${selectedInfluencerIds.length} to User` : `Assign ${getCurrentSelectedRows().length} Selected to User`}
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <FormControl fullWidth>
                        <InputLabel>Select User</InputLabel>
                        <Select
                            value={selectedUserId}
                            label="Select User"
                            onChange={(e) => setSelectedUserId(e.target.value)}
                        >
                            {users.filter(user => user.role == 'onboarder').map((user) => (
                                <MenuItem key={user._id} value={user._id}>
                                    {user.name || user.username} - {user.email}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAssignModalOpen(false)}>Cancel</Button>
                    <Button onClick={handleUserAssign} variant="contained">Assign</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={emailModalOpen} onClose={() => setEmailModalOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Send Email</DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <TextField
                        fullWidth
                        label="Email Address"
                        type="email"
                        value={emailInput}
                        onChange={(e) => setEmailInput(e.target.value)}
                        placeholder="Enter email address"
                        multiline
                        rows={4}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEmailModalOpen(false)}>Cancel</Button>
                    <Button onClick={handleSendEmail} variant="contained">Send</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default SuperAdminInfluencers;